import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { TranslateService } from '@ngx-translate/core';
import { IInputComponent } from '@nimbus-library/features/shared/components/material/i-input-component';
import { NimbusIcon } from '@nimbus-library/features/shared/directives/nimbus-icon.directive';

@Component({
  standalone: false,
  selector: 'nimbus-input-check-box',
  templateUrl: './input-check-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputCheckBoxComponent),
    },
  ],
})
export class InputCheckBoxComponent extends IInputComponent<boolean> {
  @Input()
  public labelPosition: 'before' | 'after';

  @Input()
  public icon: NimbusIcon;

  @Input()
  public intermediate: boolean = false;

  @Output()
  public valueChange: EventEmitter<MatCheckboxChange> = new EventEmitter();

  @Input()
  public set checked(val: boolean) {
    this.value = val;
  }

  public constructor(changeDetectionRef: ChangeDetectorRef, injector: Injector, translateService: TranslateService) {
    super(changeDetectionRef, injector, translateService);
  }
}
